(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["Auth0WebHeader"] = factory(require("react"));
	else
		root["Auth0WebHeader"] = factory(root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 51);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(47)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FooterList = __webpack_require__(19);

var _FooterList2 = _interopRequireDefault(_FooterList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FooterList2.default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.whitContextProvider = exports.whitContextConsumer = exports.WebHeaderContextConsumer = exports.WebHeaderContextProvider = exports.WebHeaderContext = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactContext = __webpack_require__(33);

var _createReactContext2 = _interopRequireDefault(_createReactContext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WebHeaderContext = exports.WebHeaderContext = (0, _createReactContext2.default)({});
var WebHeaderContextProvider = exports.WebHeaderContextProvider = WebHeaderContext.Provider;
var WebHeaderContextConsumer = exports.WebHeaderContextConsumer = WebHeaderContext.Consumer;
var whitContextConsumer = exports.whitContextConsumer = function whitContextConsumer(Component) {
  return function (componentProps) {
    return _react2.default.createElement(
      WebHeaderContextConsumer,
      null,
      function (providerProps) {
        return _react2.default.createElement(Component, _extends({}, componentProps, providerProps));
      }
    );
  };
};
var whitContextProvider = exports.whitContextProvider = function whitContextProvider(Component) {
  return function (componentProps) {
    var abWinnerVariant = componentProps.getAbVariantHeader ? componentProps.getAbVariantHeader() : '';
    return _react2.default.createElement(
      WebHeaderContextProvider,
      { value: { abWinnerVariant: abWinnerVariant } },
      _react2.default.createElement(Component, componentProps)
    );
  };
};

exports.default = {
  WebHeaderContext: WebHeaderContext,
  WebHeaderContextProvider: WebHeaderContextProvider,
  WebHeaderContextConsumer: WebHeaderContextConsumer
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFeaturedMessage;

var _menuItems = __webpack_require__(7);

var _menuItems2 = _interopRequireDefault(_menuItems);

var _ProbabilityBasedSelector = __webpack_require__(28);

var _ProbabilityBasedSelector2 = _interopRequireDefault(_ProbabilityBasedSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFeaturedMessage(customFeaturedMessages) {
  var variantSelector = new _ProbabilityBasedSelector2.default(customFeaturedMessages || _menuItems2.default.featuredMessages);
  return variantSelector.select();
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = {"featuredMessages":[{"link":"http://auth0.com/jobs#job-openings","title":"We are hiring!","description":"If you care deeply about quality, teamwork, and want to build software that people love.","cta":"Join Us!","iconColor":"#eb5424","probability":0.15}],"menuItems":[{"name":"Platform","id":"platform","dropdownClass":"platformDropdown","childrens":[{"componentType":"list","title":"Modern Identity Platform","description":"The enterprise-grade platform for modern identity.","key":"platform-list","twoColLayoutBig":true,"items":[{"name":"Single Sign On","description":"Connect WordPress to every login system on Earth. Really.","id":"single-sign-on","href":"https://auth0.com/single-sign-on","external":false,"icon":"<svg width=\"53\" height=\"53\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 53\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M52.509 26.254C52.509 11.754 40.755 0 26.255 0 11.755 0 0 11.754 0 26.254c0 14.5 11.755 26.254 26.255 26.254 14.5 0 26.254-11.754 26.254-26.254\" fill=\"#ECECEC\"/><g fill=\"#FFF\"><path d=\"M31.2 20.948c0-3.285-2.686-5.948-6-5.948s-6 2.663-6 5.948c0 3.285 2.686 5.949 6 5.949s6-2.664 6-5.949\" stroke=\"#EB5424\" stroke-width=\"1.62\"/><path d=\"M33.272 30.731l-6.556-2.182v-6.542a1.456 1.456 0 0 0-2.914 0V34.44l-3.253-3.248A1.495 1.495 0 0 0 18 32.245c0 .395.157.775.437 1.053l4.224 4.217c.314.314 1.14.485 1.14.485h9.471a.724.724 0 0 0 .728-.727v-5.817a.728.728 0 0 0-.728-.726v.001z\" stroke=\"#222228\" stroke-width=\"1.215\"/></g></g></svg>\n"},{"name":"Lock","description":"The Auth0 Login Box. Secure your websites and mobile apps.","id":"lock","href":"https://auth0.com/lock","external":false,"icon":"<svg height=\"53\" width=\"53\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 53\"><g fill=\"none\" stroke-linecap=\"square\"><path d=\"M52.51 26.255C52.51 11.755 40.754 0 26.254 0 11.755 0 0 11.755 0 26.255c0 14.5 11.755 26.253 26.255 26.253 14.5 0 26.254-11.754 26.254-26.254\" fill=\"#ECECEC\"/><path fill=\"#FFF\" d=\"M16.144 37.287h20.222V19.954H16.144z\"/><path stroke=\"#222228\" stroke-width=\"1.5\" d=\"M16.144 37.287h20.222V19.954H16.144zM32.032 19.953v-2.889a5.778 5.778 0 0 0-11.555 0v2.167\"/><path d=\"M29.143 27.176a2.888 2.888 0 1 0-5.778 0c0 1.066.585 1.987 1.445 2.488v3.289h2.89v-3.29a2.877 2.877 0 0 0 1.443-2.487z\" stroke=\"#EC5424\" stroke-width=\"1.5\"/></g></svg>\n"},{"name":"Breached Passwords Detection","description":"Protect your users and services from password leaks.","id":"breached-passwords-detection","href":"https://auth0.com/breached-passwords","external":false,"icon":"<svg height=\"53\" width=\"53\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 53\"><g fill=\"none\" stroke-linecap=\"square\"><path d=\"M52.51 26.255C52.51 11.755 40.753 0 26.253 0S0 11.755 0 26.255c0 14.5 11.754 26.254 26.254 26.254 14.5 0 26.255-11.754 26.255-26.254\" fill=\"#ECECEC\"/><path d=\"M26.254 17.817c-5.625 0-10.429 3.5-12.375 8.438 1.946 4.938 6.75 8.437 12.375 8.437s10.43-3.499 12.375-8.437c-1.946-4.939-6.75-8.438-12.375-8.438\" fill=\"#FFF\"/><path d=\"M26.254 17.817c-5.625 0-10.429 3.5-12.375 8.438 1.946 4.938 6.75 8.437 12.375 8.437s10.43-3.499 12.375-8.437c-1.946-4.939-6.75-8.438-12.375-8.438z\" stroke=\"#222228\" stroke-width=\"1.5\"/><path d=\"M26.254 31.145a4.893 4.893 0 0 1-4.89-4.89c0-2.7 2.19-4.892 4.89-4.892 2.7 0 4.891 2.191 4.891 4.891s-2.19 4.891-4.89 4.891z\" stroke=\"#EC5424\" stroke-width=\"1.5\"/><path d=\"M26.254 24.13a2.122 2.122 0 0 0-2.124 2.125c0 1.175.95 2.124 2.124 2.124a2.122 2.122 0 0 0 2.125-2.124 2.122 2.122 0 0 0-2.125-2.125\" fill=\"#222228\"/></g></svg>\n"},{"name":"User Management","description":"The simplest and easiest to use tools to help administrators manage users.","id":"user-management","href":"https://auth0.com/user-management","external":false,"icon":"<svg height=\"53\" width=\"53\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 53\"><g fill=\"none\" stroke-linecap=\"square\"><path d=\"M52.509 26.254C52.509 11.754 40.755 0 26.255 0 11.755 0 0 11.754 0 26.254c0 14.5 11.755 26.255 26.255 26.255 14.5 0 26.254-11.755 26.254-26.255\" fill=\"#ECECEC\"/><path d=\"M35.945 17.415c-1.088-3.784-4.558-6.28-8.683-6.315-5.06-.044-9.198 4.228-9.239 9.287v18.575h11.278v-7.298h4.272c.76.181 1.445-.435 1.698-1.196v-4.774h2.654l-1.98-8.279z\" fill=\"#FFF\" stroke=\"#222228\" stroke-width=\"1.5\"/><g stroke=\"#EB5424\"><path d=\"M30.22 24.06l1.635 1.002 1.382-2.252-1.624-.995a4.22 4.22 0 0 0 .12-.934 4.237 4.237 0 0 0-.075-.83l1.663-.92-1.28-2.311-1.674.925c-.429-.398-.94-.7-1.507-.895l.018-1.917-2.641-.026-.02 1.918a4.204 4.204 0 0 0-1.53.868l-1.663-.962-1.324 2.287 1.656.957a4.262 4.262 0 0 0-.09.823c-.004.32.035.63.1.93l-1.654.97 1.338 2.278 1.66-.974a4.2 4.2 0 0 0 1.429.827l-.02 1.941 2.643.026.02-1.94a4.204 4.204 0 0 0 1.439-.796z\"/><path d=\"M26.822 19.21a1.765 1.765 0 1 0 1.347 3.262 1.765 1.765 0 0 0-1.347-3.263z\"/></g></g></svg>\n"},{"name":"Multifactor Authentication","description":"The most usable and friction-free multifactor authentication experience.","id":"multifactor-authentication","href":"https://auth0.com/multifactor-authentication","external":false,"icon":"<svg height=\"54\" width=\"53\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 54\"><g fill=\"none\" stroke-linecap=\"square\"><path d=\"M52.51 27.108c0-14.5-11.755-26.254-26.255-26.254C11.755.854 0 12.608 0 27.108c0 14.5 11.755 26.255 26.255 26.255 14.5 0 26.254-11.755 26.254-26.255\" fill=\"#ECECEC\"/><path d=\"M32.797 41.108H19.712a1.916 1.916 0 0 1-1.91-1.91v-24.18c0-1.051.86-1.91 1.91-1.91h13.085c1.051 0 1.91.859 1.91 1.91v24.18c0 1.05-.859 1.91-1.91 1.91\" fill=\"#FFF\"/><path d=\"M32.797 41.108H19.712a1.916 1.916 0 0 1-1.91-1.91v-24.18c0-1.051.86-1.91 1.91-1.91h13.085c1.051 0 1.91.859 1.91 1.91v24.18c0 1.05-.859 1.91-1.91 1.91zM34.707 33.487H17.801M17.802 17.528h16.906\" stroke=\"#222228\" stroke-width=\"1.5\"/><path d=\"M27.828 37.32a1.573 1.573 0 1 1-3.147 0 1.573 1.573 0 0 1 3.147 0\" fill=\"#231F1F\"/><path stroke=\"#EC5424\" stroke-width=\"1.5\" d=\"M30.488 22.136l-5.414 5.413-2.107-2.107\"/></g></svg>\n"},{"name":"Passwordless","description":"Allow users to login without the need to remember a password.","id":"passwordless","href":"https://auth0.com/passwordless","external":false,"icon":"<svg height=\"54\" width=\"53\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 54\"><g fill=\"none\"><path d=\"M52.509 27.154C52.509 12.654 40.755.9 26.255.9 11.755.9 0 12.654 0 27.154c0 14.5 11.755 26.255 26.255 26.255 14.5 0 26.254-11.755 26.254-26.255\" fill=\"#ECECEC\"/><path d=\"M26.093 35.868a.593.593 0 0 0-.594.594v2.969c0 .328.265.593.594.593a.593.593 0 0 0 .594-.593v-2.97a.593.593 0 0 0-.594-.593m3.201-5.056a.615.615 0 0 0-.529.603v7.422a.618.618 0 0 0 .594.603c.313 0 .598-.29.593-.603v-7.422c.008-.337-.323-.64-.658-.603m-9.797-2.672a.616.616 0 0 0-.529.603v7.719a.619.619 0 0 0 .594.603c.314 0 .598-.29.594-.603v-7.72c.007-.336-.324-.64-.659-.602m6.596-10.678c-3.809 0-7.125 2.89-7.125 6.53v1.782a.618.618 0 0 0 .594.603.618.618 0 0 0 .594-.603v-1.781c0-2.91 2.73-5.343 5.937-5.343 3.208 0 5.937 2.434 5.937 5.343v12.469a.619.619 0 0 0 .594.603c.314 0 .598-.29.594-.603v-12.47c0-3.64-3.316-6.53-7.125-6.53m-7.793-.01a.598.598 0 0 1 .603.298.613.613 0 0 1-.065.677c-1.117 1.374-1.65 3.064-1.65 4.972v10.094a.618.618 0 0 1-.595.603.618.618 0 0 1-.593-.603V23.399c0-2.132.607-4.121 1.91-5.723a.602.602 0 0 1 .39-.223zm17.293 10.103c.33 0 .594.266.594.594v5.344a.593.593 0 1 1-1.188 0v-5.344c0-.328.265-.594.594-.594zm-9.5-13.655c-2.05 0-4.06.586-5.659 1.568a.625.625 0 0 0-.195.825c.166.265.561.35.826.186 1.398-.86 3.208-1.392 5.028-1.392 4.962 0 8.906 3.742 8.906 8.312v1.78c0 .33.265.595.594.595a.592.592 0 0 0 .594-.594v-1.781c0-5.253-4.53-9.5-10.094-9.5\" fill=\"#000\"/><path d=\"M26.028 24.28a.616.616 0 0 0-.529.604v8.312a.619.619 0 0 0 .594.603.618.618 0 0 0 .594-.603v-8.312c.007-.337-.324-.64-.659-.603\" fill=\"#EB5424\"/><path d=\"M26.093 21.025c-2.055 0-3.859 1.559-3.859 3.562v14.25a.618.618 0 0 0 .593.603c.314 0 .6-.29.594-.603v-14.25c0-1.272 1.218-2.375 2.672-2.375 1.454 0 2.672 1.103 2.672 2.375v3.859a.617.617 0 0 0 .594.603.617.617 0 0 0 .593-.603v-3.86c0-2.002-1.804-3.561-3.859-3.561\" fill=\"#EB5424\"/></g></svg>\n"}]}],"footerHighlight":true,"footerLinks":[{"id":"span-introducing-auth-0-extend-span-better-platform-extensibility-for-your-saa-s","name":"<span>Introducing Auth0 Extend:</span> Better platform extensibility for your SaaS.","href":"https://auth0.com/extend","icon":"<svg height=\"24\" width=\"16\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"none\"><path d=\"M14.516 7.422v7.286c0 1.918-1.494 3.473-3.338 3.473H9.51v4.515H6.172v-4.515h-1.67c-1.842 0-3.337-1.555-3.337-3.473V7.415H13.18l1.335.007z\" fill=\"#FFF\"/><path d=\"M14.516 7.422v7.286c0 1.918-1.494 3.473-3.338 3.473H9.51v4.515H6.172v-4.515h-1.67c-1.842 0-3.337-1.555-3.337-3.473V7.415H13.18l1.335.007z\" stroke=\"#222228\" stroke-width=\"1.155\"/><path d=\"M4.66 7.415V.978\" fill=\"#FFF\"/><path d=\"M4.66 7.415V.978\" stroke=\"#222228\" stroke-linecap=\"round\" stroke-width=\"1.155\"/><path d=\"M11.022 7.415V.978\" fill=\"#FFF\"/><path d=\"M11.022 7.415V.978\" stroke=\"#222228\" stroke-linecap=\"round\" stroke-width=\"1.155\"/><path d=\"M4.658 10.922h6.364M5.913 13.272h3.854\" stroke=\"#3445DC\" stroke-width=\"1.155\"/></g></svg>\n","external":true}]},{"name":"Solutions","id":"solutions","dropdownClass":"solutionsDropdown","twoBlockLayout":true,"childrens":[{"componentType":"list","title":"Use Cases","key":"use-cases-list","stackedList":true,"items":[{"name":"For your Customers","id":"for-your-customers","href":"https://auth0.com/b2c-customer-identity-management","external":false,"iconColor":"#C879B2","iconText":"CIAM"},{"name":"For your Business Partners","id":"for-your-business-partners","href":"https://auth0.com/b2b-enterprise-identity-management","external":false,"iconColor":"#01B48F","iconText":"B2B"},{"name":"For your Employees","id":"for-your-employees","href":"https://auth0.com/b2e-identity-management-for-employees","external":false,"iconColor":"#4571D0","iconText":"B2E"}]},{"componentType":"list","title":"Use Auth0 in","key":"solutions-list","highlight":true,"subItems":[{"titleList":"INDUSTRIES","items":[{"name":"B2B SaaS","id":"b-2-b-saa-s","href":"https://auth0.com/b2b-saas","external":false},{"name":"Financial Services","id":"financial-services","href":"https://auth0.com/financial-services","external":false},{"name":"Healthcare","id":"healthcare","href":"https://auth0.com/healthcare/","external":false},{"name":"Media","id":"media","href":"https://auth0.com/media-publishing","external":false},{"name":"Retail","id":"retail","href":"https://auth0.com/retail","external":false}]},{"titleList":"INITIATIVES","items":[{"name":"App Modernization","id":"app-modernization","href":"https://auth0.com/app-modernization","external":false},{"name":"GDPR","id":"gdpr","href":"https://auth0.com/gdpr","external":false},{"name":"MSFT ACS Migration","id":"msft-acs-migration","href":"https://auth0.com/learn/acs/","external":true}]}]}],"footerLinks":[{"id":"read-case-studies","name":"Read our Case Studies","href":"https://auth0.com/learn/#case-studies","icon":"<svg height=\"16\" width=\"16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.5 16h-13C.672 16 0 15.327 0 14.498V5.49c0-.83.672-1.5 1.5-1.5H3V1.547C3 .693 3.672 0 4.5 0h10c.828 0 1.5.693 1.5 1.548v12.904c0 .855-.672 1.548-1.5 1.548zM15 1.517A.509.509 0 0 0 14.5 1h-10c-.276 0-.5.231-.5.517v12.384H3V4.966H1.5a.5.5 0 0 0-.5.501v9.03a.5.5 0 0 0 .5.502l13-.032c.276 0 .5-.231.5-.517V1.517zM5 11.996h9v1.002H5v-1.002zm0-3.003h9v1H5v-1zm8-2.003H6a1 1 0 0 1-1-1V3.988c0-.553.448-1.002 1-1.002h7c.552 0 1 .449 1 1.002V5.99a1 1 0 0 1-1 1zm0-2.502a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.502h6a.5.5 0 0 0 .5-.502v-1z\" fill=\"#EB5424\"/></svg>\n","external":true}]},{"name":"Why Auth0","id":"why-auth0","dropdownClass":"whyDropdown","twoBlockLayout":true,"childrens":[{"componentType":"list","title":"Company","key":"company-list","items":[{"name":"About Us","id":"about-us","href":"https://auth0.com/about","external":false},{"name":"Customers","id":"customers","href":"https://auth0.com/customers","external":false},{"name":"Security, Privacy & Compliance","id":"security-privacy-compliance","href":"https://auth0.com/security","external":false},{"name":"Auth0 ROI & RCO","id":"auth-0-roi-rco","href":"https://auth0.com/forrester-total-economic-impact","external":false},{"name":"High Availability","id":"high-availability","href":"https://auth0.com/availability-trust","external":false},{"name":"Careers","id":"careers","href":"https://auth0.com/jobs","external":true},{"name":"Press","id":"press","href":"https://auth0.com/press","external":false},{"name":"Partners","id":"partners","href":"https://auth0.com/partners","external":false}]},{"componentType":"list","title":"Resources","key":"resources-list","highlight":true,"titleHref":"https://auth0.com/resources","external":true,"items":[{"name":"Whitepapers","id":"whitepapers","href":"https://auth0.com/resources/whitepapers","external":true},{"name":"Videos","id":"videos","href":"https://auth0.com/resources/videos","external":true},{"name":"Ebooks","id":"ebooks","href":"https://auth0.com/resources/ebooks","external":true},{"name":"Blog","id":"blog","href":"https://auth0.com/blog/business","external":true},{"name":"Webinars","id":"webinars","href":"https://auth0.com/resources/webinars","external":true},{"name":"Case Studies","id":"case-studies","href":"https://auth0.com/learn/#case-studies","external":true}]}]},{"name":"Developers","id":"developers","dropdownClass":"developersDropdown","twoBlockLayout":true,"childrens":[{"componentType":"list","title":"Documentation","key":"documentation-list","titleHref":"http://auth0.com/docs/","external":true,"subItems":[{"titleList":"GET STARTED","items":[{"name":"JavaScript","id":"java-script","href":"https://auth0.com/docs/quickstart/spa/vanillajs","icon":"<svg height=\"18\" width=\"18\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0 0v18h18V0H0zm9.521 15.338c-.266.54-.773.894-1.36 1.066-.903.207-1.767.089-2.41-.297-.43-.264-.765-.67-.993-1.138l1.37-.84c.012.006.048.071.097.155.174.293.325.5.621.646.292.1.93.163 1.178-.35.15-.26.102-1.098.102-2.025 0-1.456.007-2.907.007-4.347H9.82c0 1.584.009 3.084 0 4.63.004.947.086 1.792-.298 2.5zm6.995-.476c-.586 2.004-3.854 2.07-5.16.745-.276-.312-.449-.475-.613-.835.694-.399.694-.399 1.369-.79.367.564.706.874 1.316 1.001.828.101 1.66-.183 1.474-1.062-.192-.718-1.695-.893-2.718-1.66-1.038-.698-1.282-2.393-.428-3.36.284-.36.769-.626 1.278-.755l.53-.068c1.02-.021 1.658.248 2.126.77.13.133.236.275.435.583-.543.346-.541.343-1.32.847a1.255 1.255 0 0 0-.733-.68c-.452-.138-1.023.011-1.141.49-.041.147-.033.284.032.527.184.418.799.6 1.35.854 1.59.644 2.126 1.335 2.258 2.157.127.708-.031 1.167-.055 1.236z\" fill=\"#EB5424\"/></svg>\n","external":true},{"name":"iOS","id":"i-os","href":"https://auth0.com/docs/quickstart/native/ios-swift","icon":"<svg height=\"18\" width=\"15\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.426 9.563c.026 2.724 2.39 3.63 2.416 3.642-.02.064-.377 1.292-1.245 2.56-.75 1.096-1.53 2.189-2.756 2.212-1.205.022-1.593-.715-2.97-.715-1.378 0-1.809.692-2.95.737-1.184.045-2.085-1.186-2.842-2.278C.534 13.486-.648 9.406.94 6.65c.787-1.367 2.196-2.233 3.724-2.256 1.163-.022 2.26.783 2.97.783.71 0 2.044-.968 3.446-.826.587.025 2.235.237 3.293 1.786-.086.053-1.966 1.148-1.946 3.425m-2.265-6.689c.629-.76 1.052-1.82.937-2.874-.906.036-2.002.604-2.652 1.364-.582.674-1.092 1.752-.955 2.784 1.01.079 2.042-.513 2.67-1.274\" fill=\"#EB5424\"/></svg>\n","external":true},{"name":"Android","id":"android","href":"https://auth0.com/docs/quickstart/native/android","icon":"<svg height=\"18\" width=\"16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.11 5.822C.498 5.822 0 6.32 0 6.933v4.652a1.11 1.11 0 1 0 2.223 0V6.933c0-.613-.498-1.111-1.112-1.11zm8.96-4.178L10.845.23a.155.155 0 0 0-.06-.21.155.155 0 0 0-.21.061l-.783 1.43a5.33 5.33 0 0 0-2.177-.456 5.33 5.33 0 0 0-2.172.455L4.66.082A.153.153 0 0 0 4.451.02.152.152 0 0 0 4.39.23l.775 1.415c-1.524.786-2.554 2.283-2.553 4.001H12.62c0-1.719-1.027-3.213-2.55-4zM5.34 3.833a.42.42 0 1 1 .002-.84.42.42 0 0 1-.003.84zm4.556-.001a.42.42 0 1 1-.001-.839.42.42 0 0 1 0 .839zm-7.243 2.2l.002 7.21c0 .655.53 1.185 1.185 1.185h.807l.001 2.462a1.112 1.112 0 0 0 2.222-.001v-2.461h1.499v2.461a1.111 1.111 0 0 0 2.222 0v-2.462h.81c.654 0 1.185-.53 1.186-1.186l-.002-7.21-9.932.002zm12.583.9a1.11 1.11 0 1 0-2.222 0v4.652a1.11 1.11 0 1 0 2.222 0V6.93z\" fill=\"#EB5424\"/></svg>\n","external":true},{"name":"All Quickstarts","id":"all-quickstarts","href":"https://auth0.com/docs/quickstart","icon":"<svg height=\"16\" width=\"16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.429 15.787h-4.44a1.11 1.11 0 0 1-1.11-1.11v-4.44c0-.613.497-1.11 1.11-1.11h4.44c.613 0 1.11.497 1.11 1.11v4.44a1.11 1.11 0 0 1-1.11 1.11zm0-4.995a.555.555 0 0 0-.555-.555h-3.33a.555.555 0 0 0-.555.555v3.33c0 .307.249.555.555.555h3.33a.554.554 0 0 0 .555-.554v-3.33zm0-3.885h-4.44a1.11 1.11 0 0 1-1.11-1.109v-4.44c0-.613.497-1.11 1.11-1.11h4.44c.613 0 1.11.497 1.11 1.11v4.44a1.11 1.11 0 0 1-1.11 1.11zm0-4.995a.554.554 0 0 0-.555-.554h-3.33a.554.554 0 0 0-.555.554v3.33c0 .307.249.556.555.556h3.33c.307 0 .555-.25.555-.555V1.912zm-8.88 13.875H1.11A1.11 1.11 0 0 1 0 14.677v-4.44c0-.613.497-1.11 1.11-1.11h4.44c.613 0 1.11.497 1.11 1.11v4.44a1.11 1.11 0 0 1-1.11 1.11zm0-4.995a.555.555 0 0 0-.554-.555h-3.33a.555.555 0 0 0-.555.555v3.33c0 .307.249.555.555.555h3.33a.555.555 0 0 0 .555-.554v-3.33zm0-3.885H1.11A1.11 1.11 0 0 1 0 5.798v-4.44C0 .745.497.248 1.11.248h4.44c.613 0 1.11.497 1.11 1.11v4.44a1.11 1.11 0 0 1-1.11 1.11zm0-4.995a.554.554 0 0 0-.554-.554h-3.33a.554.554 0 0 0-.555.554v3.33c0 .307.249.556.555.556h3.33c.306 0 .555-.25.555-.555V1.912z\" fill=\"#EB5424\"/></svg>\n","external":true}]},{"titleList":"SECTIONS","items":[{"name":"APIs","id":"ap-is","href":"https://auth0.com/docs/api","external":true},{"name":"Protocols","id":"protocols","href":"https://auth0.com/docs/protocols","external":true},{"name":"Libraries","id":"libraries","href":"https://auth0.com/docs/libraries","external":true},{"name":"Identity Providers","id":"identity-providers","href":"https://auth0.com/docs/identityproviders"}]}]},{"componentType":"list","title":"Resources","key":"resources-list","highlight":true,"items":[{"name":"Open Source","id":"open-source","href":"https://auth0.com/opensource","external":false},{"name":"Community","id":"community","href":"https://community.auth0.com/","external":true},{"name":"Auth0 Blog","id":"auth-0-blog","href":"https://auth0.com/blog/tech/","external":true},{"name":"Knowledge Base","id":"knowledge-base","href":"https://auth0.com/learn","external":true},{"name":"Identity Glossary","id":"identity-glossary","href":"https://auth0.com/identity-glossary","external":false}]}],"footerLinks":[{"id":"latest-blog","name":"<b>Latest from Auth0 Blog:</b> Laravel 5.6 Release: What's New?","icon":"<svg height=\"16\" width=\"16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.5 16h-13C.672 16 0 15.327 0 14.498V5.49c0-.83.672-1.5 1.5-1.5H3V1.547C3 .693 3.672 0 4.5 0h10c.828 0 1.5.693 1.5 1.548v12.904c0 .855-.672 1.548-1.5 1.548zM15 1.517A.509.509 0 0 0 14.5 1h-10c-.276 0-.5.231-.5.517v12.384H3V4.966H1.5a.5.5 0 0 0-.5.501v9.03a.5.5 0 0 0 .5.502l13-.032c.276 0 .5-.231.5-.517V1.517zM5 11.996h9v1.002H5v-1.002zm0-3.003h9v1H5v-1zm8-2.003H6a1 1 0 0 1-1-1V3.988c0-.553.448-1.002 1-1.002h7c.552 0 1 .449 1 1.002V5.99a1 1 0 0 1-1 1zm0-2.502a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.502h6a.5.5 0 0 0 .5-.502v-1z\" fill=\"#EB5424\"/></svg>\n","external":true,"href":"https://auth0.com/blog/laravel-5-6-release-what-is-new/"}]},{"name":"Pricing","id":"pricing","href":"https://auth0.com/pricing"}]}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeaturedMessage = undefined;

var _WebHeader = __webpack_require__(27);

var _WebHeader2 = _interopRequireDefault(_WebHeader);

var _featured = __webpack_require__(5);

var _featured2 = _interopRequireDefault(_featured);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _WebHeader2.default;
exports.getFeaturedMessage = _featured2.default;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(2);

var _bind2 = _interopRequireDefault(_bind);

var _DropdownList = __webpack_require__(14);

var _DropdownList2 = _interopRequireDefault(_DropdownList);

var _DropdownHighlight = __webpack_require__(12);

var _DropdownHighlight2 = _interopRequireDefault(_DropdownHighlight);

var _FooterList = __webpack_require__(3);

var _FooterList2 = _interopRequireDefault(_FooterList);

var _Dropdown = __webpack_require__(34);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _State = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = _bind2.default.bind(_Dropdown2.default);

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      highlight: {}
    }, _this.setDefaultHighlight = function () {
      var data = _this.props.data;
      // Set highlight object to default highlight of the dropdown

      var highlightComponent = data.childrens.filter(function (component) {
        return !!component.default;
      });

      if (!highlightComponent.length) return;

      _this.setState({ highlight: highlightComponent[0].default });
    }, _this.highlightHandler = function (highlight) {
      if (!highlight) return;
      _this.setState({ highlight: highlight });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dropdown, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setDefaultHighlight();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setDefaultHighlight();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          closeDropdowns = _props.closeDropdowns,
          open = _props.open,
          loading = _props.loading,
          abWinnerVariant = _props.abWinnerVariant;

      return _react2.default.createElement(
        'div',
        {
          className: cx('dropdown', data.dropdownClass, {
            'is-open': open,
            twoBlock: data.twoBlockLayout
          }),
          'aria-hidden': open ? 'false' : 'true'
        },
        data.childrens.map(function (component) {
          switch (component.componentType) {
            case 'list':
              return _react2.default.createElement(_DropdownList2.default, {
                key: component.key,
                data: component,
                parentClass: data.dropdownClass,
                highlightHandler: _this2.highlightHandler,
                closeDropdowns: closeDropdowns,
                loading: loading,
                abVariant: abWinnerVariant
              });
            case 'highlight':
              return _react2.default.createElement(_DropdownHighlight2.default, {
                key: component.key,
                data: _this2.state.highlight,
                parentClass: data.dropdownClass,
                closeDropdowns: closeDropdowns,
                loading: loading
              });
            default:
              return null;
          }
        }),
        data.footerLinks ? _react2.default.createElement(
          'footer',
          { className: cx('footer-list', { 'footer-highlight': data.footerHighlight }) },
          data.footerLinks.map(function (footer) {
            return _react2.default.createElement(_FooterList2.default, {
              key: footer.id,
              footer: footer,
              closeDropdowns: closeDropdowns,
              loading: loading
            });
          })
        ) : null
      );
    }
  }]);

  return Dropdown;
}(_react.Component);

Dropdown.propTypes = {
  data: _propTypes2.default.object,
  closeDropdowns: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  loading: _propTypes2.default.bool.isRequired,
  abWinnerVariant: _propTypes2.default.string
};
Dropdown.defaultProps = {
  data: {},
  abWinnerVariant: ''
};
exports.default = (0, _State.whitContextConsumer)(Dropdown);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Dropdown = __webpack_require__(9);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Dropdown2.default;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(2);

var _bind2 = _interopRequireDefault(_bind);

var _DropdownHighlight = __webpack_require__(35);

var _DropdownHighlight2 = _interopRequireDefault(_DropdownHighlight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_DropdownHighlight2.default);

var DropdownHighlight = function DropdownHighlight(_ref) {
  var data = _ref.data,
      parentClass = _ref.parentClass,
      closeDropdowns = _ref.closeDropdowns;
  return _react2.default.createElement(
    'div',
    {
      className: cx({
        highlight: parentClass !== 'moreDropdown',
        moreHighlight: parentClass === 'moreDropdown'
      })
    },
    data.componentTitle ? _react2.default.createElement('h4', {
      className: cx('section-title'),
      dangerouslySetInnerHTML: { __html: data.componentTitle }
    }) : null,
    _react2.default.createElement(
      'a',
      {
        href: data.link,
        onClick: closeDropdowns,
        className: cx('content'),
        rel: data.external ? 'external' : null
      },
      _react2.default.createElement('img', { src: data.thumbnail, alt: data.title }),
      _react2.default.createElement(
        'h5',
        { className: cx('title') },
        data.title
      ),
      data.excerpt ? _react2.default.createElement(
        'p',
        { className: cx('text') },
        data.excerpt
      ) : null,
      data.date ? _react2.default.createElement(
        'span',
        { className: cx('time') },
        data.date
      ) : null
    ),
    _react2.default.createElement(
      'div',
      { className: cx('content') },
      (data.morelinks || []).map(function (_ref2, index) {
        var href = _ref2.href,
            text = _ref2.text,
            external = _ref2.external;
        return _react2.default.createElement(
          'a',
          {
            href: href,
            className: cx('link'),
            onClick: closeDropdowns,
            key: index,
            rel: external ? 'external' : null
          },
          text
        );
      })
    )
  );
};

DropdownHighlight.propTypes = {
  data: _propTypes2.default.object,
  parentClass: _propTypes2.default.string,
  closeDropdowns: _propTypes2.default.func
};

exports.default = DropdownHighlight;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _DropdownHighlight = __webpack_require__(11);

var _DropdownHighlight2 = _interopRequireDefault(_DropdownHighlight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DropdownHighlight2.default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(2);

var _bind2 = _interopRequireDefault(_bind);

var _DropdownListItem = __webpack_require__(16);

var _DropdownListItem2 = _interopRequireDefault(_DropdownListItem);

var _FooterList = __webpack_require__(3);

var _FooterList2 = _interopRequireDefault(_FooterList);

var _DropdownList = __webpack_require__(36);

var _DropdownList2 = _interopRequireDefault(_DropdownList);

var _UtilsAbTest = __webpack_require__(29);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_DropdownList2.default);

var DropdownList = function DropdownList(_ref) {
  var data = _ref.data,
      highlightHandler = _ref.highlightHandler,
      parentClass = _ref.parentClass,
      closeDropdowns = _ref.closeDropdowns,
      loading = _ref.loading,
      abVariant = _ref.abVariant;
  return _react2.default.createElement(
    'div',
    {
      className: cx('dropdownList', {
        moreDropdownList: parentClass === 'moreDropdown',
        stackedList: data.stackedList,
        twoColList: data.twoColLayout,
        twoColListBig: data.twoColLayoutBig,
        highlight: data.highlight
      })
    },
    data.title ? _react2.default.createElement(
      'header',
      { className: cx('header-title') },
      data.titleHref ? _react2.default.createElement(
        'a',
        {
          className: cx('section-title', { hasArrow: data.titleHref, loading: loading }),
          href: data.titleHref,
          rel: data.external ? 'external' : ''
        },
        data.title
      ) : _react2.default.createElement(
        'h4',
        { className: cx('section-title', { loading: loading }) },
        data.title
      ),
      data.description ? _react2.default.createElement('span', {
        className: cx('section-description', { loading: loading }),
        dangerouslySetInnerHTML: { __html: data.description }
      }) : null
    ) : null,
    data.subItems ? _react2.default.createElement(
      'div',
      { className: cx('multi-list') },
      data.subItems.map(function (subItem) {
        return _react2.default.createElement(
          'ul',
          { role: 'menubar', key: subItem.titleList },
          subItem.titleList ? _react2.default.createElement(
            'span',
            { className: cx('title-list', { loading: loading }) },
            subItem.titleList
          ) : null,
          (subItem.items || []).map(function (item) {
            var useABVariant = _UtilsAbTest.arrayItems.includes(item.id) && abVariant === _UtilsAbTest.abVariantName;
            var dataItem = useABVariant ? _UtilsAbTest.contentItems[item.id] : item;
            return _react2.default.createElement(_DropdownListItem2.default, {
              key: dataItem.id,
              item: dataItem,
              highlightHandler: highlightHandler,
              hasArrow: subItem.hasArrows,
              parentClass: parentClass,
              closeDropdowns: closeDropdowns,
              loading: loading
            });
          })
        );
      })
    ) : null,
    data.items ? _react2.default.createElement(
      'ul',
      { role: 'menubar' },
      (data.items || []).map(function (item) {
        return _react2.default.createElement(_DropdownListItem2.default, {
          key: item.id,
          item: item,
          highlightHandler: highlightHandler,
          hasArrow: data.hasArrows,
          parentClass: parentClass,
          closeDropdowns: closeDropdowns,
          loading: loading
        });
      })
    ) : null,
    data.footerLinks ? _react2.default.createElement(
      'footer',
      { className: cx('footer-list') },
      data.footerLinks.map(function (footer) {
        return _react2.default.createElement(_FooterList2.default, { key: footer.id, footer: footer, closeDropdowns: closeDropdowns });
      })
    ) : null
  );
};

DropdownList.propTypes = {
  data: _propTypes2.default.object,
  highlightHandler: _propTypes2.default.func,
  parentClass: _propTypes2.default.string,
  closeDropdowns: _propTypes2.default.func,
  loading: _propTypes2.default.bool.isRequired,
  abVariant: _propTypes2.default.string
};

exports.default = DropdownList;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _DropdownList = __webpack_require__(13);

var _DropdownList2 = _interopRequireDefault(_DropdownList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DropdownList2.default;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(2);

var _bind2 = _interopRequireDefault(_bind);

var _DropdownListItem = __webpack_require__(37);

var _DropdownListItem2 = _interopRequireDefault(_DropdownListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = _bind2.default.bind(_DropdownListItem2.default);

var DropdownListItem = function (_Component) {
  _inherits(DropdownListItem, _Component);

  function DropdownListItem() {
    _classCallCheck(this, DropdownListItem);

    return _possibleConstructorReturn(this, (DropdownListItem.__proto__ || Object.getPrototypeOf(DropdownListItem)).apply(this, arguments));
  }

  _createClass(DropdownListItem, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      /* eslint-env browser */
      var item = this.props.item;

      if (item.highlight && item.highlight.thumbnail) {
        var preloadImage = new Image();
        preloadImage.src = item.highlight.thumbnail;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          hasArrow = _props.hasArrow,
          parentClass = _props.parentClass,
          highlightHandler = _props.highlightHandler,
          item = _props.item,
          closeDropdowns = _props.closeDropdowns,
          loading = _props.loading;

      var linkExternal = item.external ? 'external' : null;
      return _react2.default.createElement(
        'li',
        {
          className: cx({
            item: !hasArrow,
            arrowItem: hasArrow,
            moreItem: parentClass === 'moreDropdown'
          }),
          onMouseEnter: function onMouseEnter() {
            highlightHandler(item.highlight);
          },
          onFocus: function onFocus() {
            highlightHandler(item.highlight);
          },
          role: 'menuitem'
        },
        _react2.default.createElement(
          'a',
          {
            className: cx({
              'icon-css': item.iconColor && item.iconText
            }),
            href: item.href,
            onClick: closeDropdowns,
            rel: linkExternal
          },
          item.icon && _react2.default.createElement('figure', {
            className: cx('icon', { loading: loading }),
            dangerouslySetInnerHTML: { __html: item.icon }
          }),
          item.iconColor && item.iconText && _react2.default.createElement(
            'figure',
            { className: cx('icon', { loading: loading }) },
            _react2.default.createElement(
              'span',
              {
                style: {
                  backgroundColor: item.iconColor,
                  width: 46,
                  height: 30,
                  display: 'inline-block',
                  color: '#F5F7F9',
                  borderRadius: 3,
                  textAlign: 'center',
                  fontSize: 12,
                  fontWeight: 500,
                  textTransform: 'uppercase',
                  padding: 7
                }
              },
              item.iconText
            )
          ),
          _react2.default.createElement(
            'span',
            { className: cx('text') },
            _react2.default.createElement(
              'span',
              { className: cx({ loading: loading }) },
              item.name
            ),
            item.prefix ? _react2.default.createElement(
              'span',
              { className: cx('itemPrefix', { loading: loading }) },
              item.prefix
            ) : null
          ),
          item.description ? _react2.default.createElement(
            'p',
            { className: cx('item-description', { loading: loading }) },
            item.description
          ) : null
        )
      );
    }
  }]);

  return DropdownListItem;
}(_react.Component);

DropdownListItem.propTypes = {
  item: _propTypes2.default.object,
  highlightHandler: _propTypes2.default.func,
  hasArrow: _propTypes2.default.bool,
  parentClass: _propTypes2.default.string,
  closeDropdowns: _propTypes2.default.func,
  loading: _propTypes2.default.bool.isRequired
};
exports.default = DropdownListItem;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _DropdownListItem = __webpack_require__(15);

var _DropdownListItem2 = _interopRequireDefault(_DropdownListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DropdownListItem2.default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(2);

var _bind2 = _interopRequireDefault(_bind);

var _FeaturedHead = __webpack_require__(38);

var _FeaturedHead2 = _interopRequireDefault(_FeaturedHead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = _bind2.default.bind(_FeaturedHead2.default);

var FeaturedHead = function (_Component) {
  _inherits(FeaturedHead, _Component);

  function FeaturedHead() {
    _classCallCheck(this, FeaturedHead);

    return _possibleConstructorReturn(this, (FeaturedHead.__proto__ || Object.getPrototypeOf(FeaturedHead)).apply(this, arguments));
  }

  _createClass(FeaturedHead, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          iconColor = _props.iconColor,
          link = _props.link,
          title = _props.title,
          description = _props.description,
          cta = _props.cta,
          theme = _props.theme,
          dropdownOpen = _props.dropdownOpen,
          notificationOpen = _props.notificationOpen,
          closeNotificationHandler = _props.closeNotificationHandler,
          loading = _props.loading;


      return _react2.default.createElement(
        'div',
        { className: cx('featured', ['theme-' + theme], { dropdownOpen: dropdownOpen }, { notificationOpen: notificationOpen }) },
        _react2.default.createElement(
          'div',
          { className: cx('featured-content') },
          _react2.default.createElement(
            'a',
            { href: link, rel: 'external' },
            _react2.default.createElement('span', {
              className: cx('featured-icon'),
              style: {
                backgroundColor: iconColor
              }
            }),
            _react2.default.createElement(
              'span',
              {
                className: cx('featured-title', { loading: loading }),
                style: {
                  color: iconColor
                }
              },
              title
            ),
            _react2.default.createElement(
              'span',
              { className: cx('featured-description', { loading: loading }) },
              description
            ),
            _react2.default.createElement(
              'span',
              { className: cx('featured-more', { loading: loading }) },
              cta
            )
          ),
          _react2.default.createElement(
            'button',
            {
              type: 'button',
              className: cx('close-notification'),
              onClick: closeNotificationHandler
            },
            _react2.default.createElement(
              'span',
              { className: 'sr-only' },
              'Close featured banner'
            )
          )
        )
      );
    }
  }]);

  return FeaturedHead;
}(_react.Component);

FeaturedHead.propTypes = {
  iconColor: _propTypes2.default.string,
  link: _propTypes2.default.string,
  title: _propTypes2.default.string,
  description: _propTypes2.default.string,
  cta: _propTypes2.default.string,
  theme: _propTypes2.default.string,
  dropdownOpen: _propTypes2.default.bool,
  notificationOpen: _propTypes2.default.bool,
  closeNotificationHandler: _propTypes2.default.func,
  loading: _propTypes2.default.bool.isRequired
};
FeaturedHead.defaultProps = {
  iconColor: null,
  link: null,
  title: null,
  description: null,
  cta: null
};
exports.default = FeaturedHead;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FeaturedHead = __webpack_require__(17);

var _FeaturedHead2 = _interopRequireDefault(_FeaturedHead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FeaturedHead2.default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(2);

var _bind2 = _interopRequireDefault(_bind);

var _FooterList = __webpack_require__(39);

var _FooterList2 = _interopRequireDefault(_FooterList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_FooterList2.default);

var FooterList = function FooterList(_ref) {
  var footer = _ref.footer,
      closeDropdowns = _ref.closeDropdowns,
      loading = _ref.loading;
  return _react2.default.createElement(
    'a',
    {
      className: cx('footer-link'),
      href: footer.href,
      onClick: closeDropdowns,
      rel: footer.external ? 'external' : null
    },
    footer.icon && _react2.default.createElement('span', { className: cx('icon', { loading: loading }), dangerouslySetInnerHTML: { __html: footer.icon } }),
    _react2.default.createElement('span', { className: cx('text', { loading: loading }), dangerouslySetInnerHTML: { __html: footer.name } })
  );
};

FooterList.propTypes = {
  footer: _propTypes2.default.object,
  closeDropdowns: _propTypes2.default.func,
  loading: _propTypes2.default.bool.isRequired
};

exports.default = FooterList;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(2);

var _bind2 = _interopRequireDefault(_bind);

var _FooterMobile = __webpack_require__(40);

var _FooterMobile2 = _interopRequireDefault(_FooterMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = _bind2.default.bind(_FooterMobile2.default);

var FooterMobile = function (_Component) {
  _inherits(FooterMobile, _Component);

  function FooterMobile() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FooterMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FooterMobile.__proto__ || Object.getPrototypeOf(FooterMobile)).call.apply(_ref, [this].concat(args))), _this), _this.clickHandler = function () {
      _this.props.onClick();
      return true;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FooterMobile, [{
    key: 'render',
    value: function render() {
      var mobileLinks = this.props.mobileLinks;


      var linkExternal = mobileLinks.external ? 'external' : null;
      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          {
            className: cx('mobile-link'),
            onClick: this.clickHandler,
            href: mobileLinks.href,
            rel: linkExternal
          },
          mobileLinks.name
        )
      );
    }
  }]);

  return FooterMobile;
}(_react.Component);

FooterMobile.propTypes = {
  mobileLinks: _propTypes2.default.object,
  onClick: _propTypes2.default.func.isRequired
};
exports.default = FooterMobile;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _FooterMobile = __webpack_require__(20);

var _FooterMobile2 = _interopRequireDefault(_FooterMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FooterMobile2.default;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(2);

var _bind2 = _interopRequireDefault(_bind);

var _Head = __webpack_require__(41);

var _Head2 = _interopRequireDefault(_Head);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_Head2.default);

var Head = function Head(_ref) {
  var toggleDropdownHandler = _ref.toggleDropdownHandler,
      dropdownOpen = _ref.dropdownOpen,
      theme = _ref.theme,
      closeHeaderDropdown = _ref.closeHeaderDropdown;
  return _react2.default.createElement(
    'div',
    {
      className: cx('head', ['theme-' + theme], {
        dropdownOpen: dropdownOpen
      })
    },
    _react2.default.createElement(
      'button',
      {
        type: 'button',
        className: cx('toggleButton', 'collapsed', { closeButton: dropdownOpen }),
        onClick: toggleDropdownHandler
      },
      _react2.default.createElement(
        'span',
        { className: 'sr-only' },
        'Toggle navigation'
      ),
      _react2.default.createElement('span', { className: cx('iconBar') }),
      _react2.default.createElement('span', { className: cx('iconBar') }),
      _react2.default.createElement('span', { className: cx('iconBar') }),
      _react2.default.createElement('span', { className: cx('iconBar') })
    ),
    _react2.default.createElement(
      'h1',
      { className: cx('brand') },
      _react2.default.createElement(
        'a',
        { href: '/', rel: 'home', className: cx('logo'), onClick: closeHeaderDropdown },
        _react2.default.createElement(
          'span',
          null,
          'Auth0'
        )
      )
    )
  );
};

Head.propTypes = {
  toggleDropdownHandler: _propTypes2.default.func,
  dropdownOpen: _propTypes2.default.bool,
  theme: _propTypes2.default.string,
  closeHeaderDropdown: _propTypes2.default.func
};

exports.default = Head;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Head = __webpack_require__(22);

var _Head2 = _interopRequireDefault(_Head);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Head2.default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(2);

var _bind2 = _interopRequireDefault(_bind);

var _Dropdown = __webpack_require__(10);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Item = __webpack_require__(42);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = _bind2.default.bind(_Item2.default);

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Item);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      openDropdown: false
    }, _this.handleDropdown = function (e) {
      var openDropdown = _this.state.openDropdown;
      var mobile = _this.props.mobile;

      var isMobile = mobile;
      var shouldOpenDropdown = ['mouseenter', 'focus'].indexOf(e.type) > -1;

      if (shouldOpenDropdown === openDropdown || isMobile) return;

      _this.setState({ openDropdown: shouldOpenDropdown });
    }, _this.closeItemDropdown = function () {
      var isDesktop = !_this.props.mobile;
      var isDropdownOpen = _this.state.openDropdown;

      if (isDesktop && isDropdownOpen) {
        _this.setState({ openDropdown: false });
      }
    }, _this.closeDropdowns = function () {
      _this.closeItemDropdown();
      _this.props.closeHeaderDropdown();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Item, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          item = _props.item,
          theme = _props.theme,
          simpleList = _props.simpleList,
          mobile = _props.mobile,
          loading = _props.loading;


      var linkContent = _react2.default.createElement(ItemContent, { name: item.name, childrens: item.childrens, theme: theme });
      var linkHref = (mobile ? item.mobileHref : null) || item.href;
      var linkExternal = item.external ? 'external' : null;

      return _react2.default.createElement(
        'li',
        {
          className: cx('item', ['item-' + item.id], ['theme-' + theme], {
            'simple-list': simpleList,
            'is-dropdown-open': this.state.openDropdown
          }),
          onMouseEnter: this.handleDropdown,
          onFocus: this.handleDropdown,
          onMouseLeave: this.handleDropdown,
          onBlur: this.handleDropdown,
          role: 'menuitem',
          'aria-haspopup': 'true'
        },
        linkHref ? _react2.default.createElement(
          'a',
          {
            href: linkHref,
            onClick: this.closeDropdowns,
            className: cx('link'),
            rel: linkExternal
          },
          linkContent
        ) : _react2.default.createElement(
          'span',
          { tabIndex: '0', className: cx('link') },
          linkContent
        ),
        item.childrens ? _react2.default.createElement(_Dropdown2.default, {
          data: item,
          closeDropdowns: this.closeDropdowns,
          open: this.state.openDropdown,
          loading: loading
        }) : null
      );
    }
  }]);

  return Item;
}(_react.Component);

Item.propTypes = {
  item: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    name: _propTypes2.default.string,
    mobileHref: _propTypes2.default.string,
    dropdownClass: _propTypes2.default.string,
    simpleList: _propTypes2.default.bool,
    children: _propTypes2.default.arrayOf(_propTypes2.default.object)
  }),
  theme: _propTypes2.default.string,
  simpleList: _propTypes2.default.bool,
  closeHeaderDropdown: _propTypes2.default.func,
  mobile: _propTypes2.default.bool,
  loading: _propTypes2.default.bool.isRequired
};
exports.default = Item;


var ItemContent = function ItemContent(_ref2) {
  var name = _ref2.name,
      childrens = _ref2.childrens,
      theme = _ref2.theme;
  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'span',
      { className: cx('text') },
      name
    ),
    childrens ? _react2.default.createElement(
      'svg',
      { width: '8', height: '4', viewBox: '62 7 10 6', className: cx('item-caret') },
      _react2.default.createElement('path', {
        // eslint-disable-next-line max-len
        d: 'M71.884 7.698l-4.56 5.116c-.013.022-.008.05-.026.07-.083.084-.192.12-.3.116-.106.004-.214-.033-.295-.117-.02-.02-.014-.047-.028-.068L62.115 7.7c-.154-.16-.154-.42 0-.58.156-.16.408-.16.563 0L67 11.97l4.322-4.85c.155-.16.406-.16.56 0 .157.16.157.418.002.578z',
        fill: theme === 'dark' ? '#fff' : '#000'
      })
    ) : null,
    childrens ? _react2.default.createElement('span', { className: cx('dropdown-caret') }) : null
  );
};

ItemContent.propTypes = {
  name: _propTypes2.default.string,
  childrens: _propTypes2.default.array,
  theme: _propTypes2.default.string
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Item = __webpack_require__(24);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Item2.default;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = __webpack_require__(2);

var _bind2 = _interopRequireDefault(_bind);

var _classnames = __webpack_require__(31);

var _classnames2 = _interopRequireDefault(_classnames);

var _Head = __webpack_require__(23);

var _Head2 = _interopRequireDefault(_Head);

var _FeaturedHead = __webpack_require__(18);

var _FeaturedHead2 = _interopRequireDefault(_FeaturedHead);

var _Item = __webpack_require__(25);

var _Item2 = _interopRequireDefault(_Item);

var _FooterMobile = __webpack_require__(21);

var _FooterMobile2 = _interopRequireDefault(_FooterMobile);

var _menuItems = __webpack_require__(7);

var _menuItems2 = _interopRequireDefault(_menuItems);

var _mobileItems = __webpack_require__(50);

var _mobileItems2 = _interopRequireDefault(_mobileItems);

var _WebHeader = __webpack_require__(43);

var _WebHeader2 = _interopRequireDefault(_WebHeader);

var _featured = __webpack_require__(5);

var _featured2 = _interopRequireDefault(_featured);

var _State = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var cx = _bind2.default.bind(_WebHeader2.default);

var WebHeader = function (_Component) {
  _inherits(WebHeader, _Component);

  function WebHeader() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, WebHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = WebHeader.__proto__ || Object.getPrototypeOf(WebHeader)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      navbarDropdownIsOpen: false,
      notificationIsOpen: true,
      mobileState: true,
      menuItems: _menuItems2.default.menuItems,
      menuItemsMobile: _mobileItems2.default,
      featuredMessage: (0, _featured2.default)(),
      loading: true
    }, _this.setHeightDropdown = function () {
      var height = _this.state.mobileState ? window.innerHeight - 70 + 'px' : '';
      _this.dropdownContent.style.height = height;
    }, _this.injectContent = function (content) {
      if (!content) {
        return _this.setState({
          loading: false
        });
      }

      return _this.setState({
        menuItems: content.menuItems,
        featuredMessage: (0, _featured2.default)(content.featuredMessages),
        loading: false
      });
    }, _this.handleResize = function () {
      var mobileState = window.innerWidth < _this.props.breakpoint;
      _this.setState({ mobileState: mobileState }, function () {
        _this.addOverflowBody();
        _this.setHeightDropdown();
      });
    }, _this.navbarDropdownHandler = function () {
      _this.setState({ navbarDropdownIsOpen: !_this.state.navbarDropdownIsOpen }, _this.addOverflowBody);
    }, _this.closeDropdownOnButtonClick = function (callback) {
      return function (event) {
        var isMobile = _this.state.mobileState;
        var isDropdownOpen = _this.state.navbarDropdownIsOpen;

        if (callback) callback(event);
        if (isMobile && isDropdownOpen) _this.navbarDropdownHandler();
      };
    }, _this.handleKeyDown = function (e) {
      // Only enable focusable elements on key tab pressed
      if (e.keyCode !== 9 || _this.state.focusable) return;
      _this.setState({ focusable: true });
    }, _this.notificationHandler = function () {
      _this.setState({ notificationIsOpen: !_this.state.notificationIsOpen });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WebHeader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      /* eslint-env browser */
      var _window = window,
          headerContentInjector = _window.headerContentInjector;

      var callback = function callback(items) {
        return _this2.injectContent(items);
      };

      if (headerContentInjector) {
        headerContentInjector.onContentLoad(callback);
      }

      if (!headerContentInjector && window.headerContentInjectorCallback) {
        window.headerContentInjectorCallback.push(callback);
      }

      if (!headerContentInjector && !window.headerContentInjectorCallback) {
        window.headerContentInjectorCallback = [callback];
      }

      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'addOverflowBody',
    value: function addOverflowBody() {
      var _state = this.state,
          navbarDropdownIsOpen = _state.navbarDropdownIsOpen,
          mobileState = _state.mobileState;


      if (navbarDropdownIsOpen && mobileState) {
        document.body.classList.add(cx('overflow'));
      } else {
        document.body.classList.remove(cx('overflow'));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          theme = _props.theme,
          featuredEnable = _props.featuredEnable,
          featuredIconColor = _props.featuredIconColor,
          featuredLink = _props.featuredLink,
          featuredTitle = _props.featuredTitle,
          featuredDescription = _props.featuredDescription,
          featuredCTA = _props.featuredCTA,
          signupButtonEnable = _props.signupButtonEnable,
          signupButtonLink = _props.signupButtonLink,
          signupButtonOnClick = _props.signupButtonOnClick,
          signupButtonText = _props.signupButtonText,
          talkToSalesButtonEnable = _props.talkToSalesButtonEnable,
          talkToSalesButtonLink = _props.talkToSalesButtonLink,
          talkToSalesButtonOnClick = _props.talkToSalesButtonOnClick,
          talkToSalesButtonText = _props.talkToSalesButtonText,
          loginButtonEnable = _props.loginButtonEnable,
          loginButtonLink = _props.loginButtonLink,
          loginButtonOnClick = _props.loginButtonOnClick,
          loginButtonText = _props.loginButtonText,
          userProfile = _props.userProfile;
      var _state2 = this.state,
          navbarDropdownIsOpen = _state2.navbarDropdownIsOpen,
          mobileState = _state2.mobileState,
          focusable = _state2.focusable,
          menuItems = _state2.menuItems,
          menuItemsMobile = _state2.menuItemsMobile,
          notificationIsOpen = _state2.notificationIsOpen,
          featuredMessage = _state2.featuredMessage,
          loading = _state2.loading;


      var signupButton = WebHeader.renderButton(signupButtonLink, this.closeDropdownOnButtonClick(signupButtonOnClick), signupButtonText, 'btn btn-success btn-sm ' + cx('signup-button'));
      var talkToSalesButton = WebHeader.renderButton(talkToSalesButtonLink, this.closeDropdownOnButtonClick(talkToSalesButtonOnClick), talkToSalesButtonText, 'btn btn-transparent btn-sm talk-button');
      var loginButton = WebHeader.renderButton(loginButtonLink, this.closeDropdownOnButtonClick(loginButtonOnClick), loginButtonText, cx('login-button', { 'login-button--dark': theme === 'dark' }));

      var renderedMenuMobile = menuItemsMobile.map(function (mobileLinks, i) {
        return _react2.default.createElement(_FooterMobile2.default, {
          onClick: _this3.navbarDropdownHandler,
          key: mobileLinks.id,
          mobileLinks: mobileLinks
        });
      });

      var renderedMenuItems = menuItems.map(function (item, i) {
        return _react2.default.createElement(_Item2.default, {
          key: i + item.id,
          item: item,
          theme: theme,
          simpleList: item.simpleList,
          closeHeaderDropdown: _this3.closeDropdownOnButtonClick(),
          mobile: mobileState,
          loading: loading
        });
      });

      /* eslint-disable jsx-a11y/no-static-element-interactions */
      return _react2.default.createElement(
        'header',
        { className: cx('header-main', { 'is-notification-open': notificationIsOpen }) },
        featuredEnable && _react2.default.createElement(_FeaturedHead2.default, _extends({
          iconColor: featuredIconColor,
          link: featuredLink,
          title: featuredTitle,
          description: featuredDescription,
          cta: featuredCTA,
          dropdownOpen: navbarDropdownIsOpen,
          notificationOpen: notificationIsOpen,
          theme: theme,
          closeNotificationHandler: this.notificationHandler,
          loading: loading
        }, featuredMessage)),
        _react2.default.createElement(
          'div',
          {
            className: cx('header', ['theme-' + theme], className, {
              'is-dropdown-open': navbarDropdownIsOpen,
              focusable: focusable
            }),
            onKeyDown: this.handleKeyDown
          },
          _react2.default.createElement(
            'div',
            { className: cx('menu', { 'is-dropdown-open': navbarDropdownIsOpen }) },
            _react2.default.createElement(
              'div',
              { className: 'container' },
              _react2.default.createElement(_Head2.default, {
                toggleDropdownHandler: this.navbarDropdownHandler,
                dropdownOpen: navbarDropdownIsOpen,
                theme: theme,
                closeHeaderDropdown: this.closeDropdownOnButtonClick()
              }),
              _react2.default.createElement(
                'div',
                {
                  className: cx('collapse', {
                    'is-dropdown-open': navbarDropdownIsOpen
                  }),
                  ref: function ref(_ref) {
                    _this3.dropdownContent = _ref;
                  }
                },
                _react2.default.createElement(
                  'nav',
                  { className: cx('main-navigation'), role: 'navigation', 'aria-label': 'Main menu' },
                  _react2.default.createElement(
                    'ul',
                    { className: cx('navigation'), role: 'menubar' },
                    children || renderedMenuItems,
                    _react2.default.createElement(
                      'li',
                      {
                        className: (0, _classnames2.default)({
                          'theme-dark': theme === 'dark'
                        })
                      },
                      talkToSalesButtonEnable && talkToSalesButton
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: cx('menu-mobile') },
                    talkToSalesButtonEnable && talkToSalesButton,
                    _react2.default.createElement(
                      'ul',
                      null,
                      renderedMenuMobile
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: (0, _classnames2.default)(cx('buttons-group'), {
                      'theme-dark': theme === 'dark'
                    })
                  },
                  loginButtonEnable && loginButton,
                  signupButtonEnable && signupButton,
                  userProfile
                )
              )
            )
          )
        )
      );
    }
  }], [{
    key: 'renderButton',
    value: function renderButton(link, onClick, text, className) {
      return link ? _react2.default.createElement(
        'a',
        { href: link, className: className, onClick: onClick },
        text
      ) : _react2.default.createElement(
        'button',
        { className: className, onClick: onClick },
        text
      );
    }
  }]);

  return WebHeader;
}(_react.Component);

WebHeader.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  theme: _propTypes2.default.oneOf(['light', 'gray', 'dark']),
  featuredEnable: _propTypes2.default.bool,
  featuredIconColor: _propTypes2.default.string,
  featuredLink: _propTypes2.default.string,
  featuredTitle: _propTypes2.default.string,
  featuredDescription: _propTypes2.default.string,
  featuredCTA: _propTypes2.default.string,
  loginButtonEnable: _propTypes2.default.bool,
  loginButtonLink: _propTypes2.default.string,
  loginButtonOnClick: _propTypes2.default.func,
  loginButtonText: _propTypes2.default.string,
  signupButtonEnable: _propTypes2.default.bool,
  signupButtonLink: _propTypes2.default.string,
  signupButtonOnClick: _propTypes2.default.func,
  signupButtonText: _propTypes2.default.string,
  talkToSalesButtonEnable: _propTypes2.default.bool,
  talkToSalesButtonLink: _propTypes2.default.string,
  talkToSalesButtonOnClick: _propTypes2.default.func,
  talkToSalesButtonText: _propTypes2.default.string,
  userProfile: _propTypes2.default.node,
  breakpoint: _propTypes2.default.number,
  getAbVariantHeader: _propTypes2.default.func
};
WebHeader.defaultProps = {
  className: '',
  children: null,
  theme: 'light',
  featuredEnable: true,
  featuredIconColor: null,
  featuredLink: null,
  featuredTitle: null,
  featuredDescription: null,
  featuredCTA: null,
  loginButtonEnable: true,
  loginButtonLink: '',
  loginButtonOnClick: function loginButtonOnClick() {},
  loginButtonText: 'Log In',
  signupButtonEnable: true,
  signupButtonLink: '',
  signupButtonOnClick: function signupButtonOnClick() {},
  signupButtonText: 'Sign up',
  talkToSalesButtonEnable: true,
  talkToSalesButtonLink: '?contact=true',
  talkToSalesButtonOnClick: function talkToSalesButtonOnClick() {},
  talkToSalesButtonText: 'Talk to Sales',
  userProfile: null,
  breakpoint: 992,
  getAbVariantHeader: function getAbVariantHeader() {}
};
exports.default = (0, _State.whitContextProvider)(WebHeader);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _WebHeader = __webpack_require__(26);

var _WebHeader2 = _interopRequireDefault(_WebHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _WebHeader2.default;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(30);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProbabilityBasedSelector = function ProbabilityBasedSelector(variants) {
  var _this = this;

  _classCallCheck(this, ProbabilityBasedSelector);

  this.select = function () {
    var random = _this.getRandom();
    var intervals = _this.getIntervals();

    var winner = intervals.find(function (interval) {
      return random >= interval.from && random < interval.to;
    });

    return winner ? winner.variant : null;
  };

  this.getRandom = function () {
    return Math.random();
  };

  this.getTotal = function () {
    return _this.variants.reduce(function (soFar, variant) {
      return soFar + variant.probability;
    }, 0);
  };

  this.getIntervals = function () {
    var lastTo = 0;
    var total = _this.getTotal();
    var thereIsOne = _this.variants.find(function (variant) {
      return variant.probability === 1;
    });

    return _this.variants.map(function (variant) {
      var probability = variant.probability;
      var from = lastTo;
      var to = probability / total + from;
      lastTo = to;

      if (thereIsOne && probability === 1) {
        from = 0;
        to = 1;
      }

      if (thereIsOne && probability !== 1) {
        from = 0;
        to = 0;
      }

      return { variant: variant, from: from, to: to };
    });
  };

  this.variants = variants;
}

// NOTE: This assumes that Math.random is good enough for the purpose
// of this library
;

exports.default = ProbabilityBasedSelector;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var abVariantName = exports.abVariantName = 'replaceItems';
var contentItems = exports.contentItems = {
  'java-script': {
    name: 'Single Page App',
    id: 'single-page-app',
    href: 'https://auth0.com/docs/quickstart/spa',
    external: true,
    icon: '<svg width="18px" height="19px" viewBox="0 0 18 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="singlepageapp" fill="#EB5424" fill-rule="nonzero"><polygon id="Shape" points="7.6 11 4.2 16.9 0 9.7 6.9 9.7"></polygon><polygon id="Shape" points="7.6 7.6 6.9 8.9 0 8.9 4.2 1.7"></polygon><polygon id="Shape" points="17.4 9.7 17.2 10 16.8 10.7 12.2 18.6 5 18.6 8.6 12.4 9.6 10.7 9.6 10.7 10 10 10 10 10.1 9.7"></polygon><polygon id="Shape" points="17.4 8.9 10.1 8.9 10 8.6 10 8.6 9.6 8 9.6 7.9 8.6 6.3 5 0 12.2 0 16.8 7.9 17.2 8.6"></polygon></g></g></svg>'
  },
  'i-os': {
    name: 'Web App',
    id: 'web-app',
    href: 'https://auth0.com/docs/quickstart/webapp',
    external: true,
    icon: '<svg width="18px" height="19px" viewBox="0 0 18 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="webapp" transform="translate(0.000000, -1.000000)" fill="#EB5424" fill-rule="nonzero"><path d="M13.8,15.1 C14.7,15.5 15.8,15.4 16.5,14.8 C16.8,14.5 17.1,14.2 17.3,13.8 L17.3,13.7 L17.3,13.6 L17.3,13.5 C17.5,12.9 17.7,12.3 17.8,11.7 C18.1,10.3 18,8.8 17.5,7.4 C17.2,6.5 16.8,5.5 16.1,4.7 C15,3.2 13.5,2.2 11.9,1.6 C12.2,2.1 12.4,2.7 12.5,3.3 C12.7,4.8 12.1,6.2 11,7.2 C11.3,7.4 11.6,7.7 11.8,8 C12.3,8.7 12.5,9.5 12.5,10.3 C12.5,10.7 12.4,11.2 12.2,11.6 C11.8,12.9 12.4,14.5 13.8,15.1 Z" id="Shape"></path><path d="M1.8,15.4 C2.2,16 2.7,16.5 3.2,17 C4.3,18 5.7,18.6 7.1,18.9 C9.6,19.5 12.3,19 14.5,17.3 C14.7,17.2 14.8,17.1 14.9,17 C14.3,17 13.7,16.9 13.1,16.6 C11.7,16 10.8,14.7 10.5,13.3 C9.4,13.8 8.1,13.7 7.1,13 C6.7,12.8 6.4,12.5 6.1,12.1 C5.3,11 3.6,10.7 2.3,11.6 C1.1,12.5 0.9,14.2 1.8,15.4 Z" id="Shape"></path> <path d="M0.1,11.6 C0.4,11.1 0.8,10.6 1.3,10.3 C2.5,9.4 4.1,9.2 5.4,9.7 C5.5,8.7 6,7.8 6.8,7.2 C7.1,7 7.2,6.9 7.4,6.8 C7.8,6.6 8.2,6.5 8.7,6.4 C9.2,6.4 9.6,6.2 10,5.9 C10.8,5.3 11.2,4.4 11.1,3.4 C10.9,2 9.7,0.9 8.2,1 L8.1,1 L8,1 C7.3,1.1 6.7,1.3 6,1.5 C5.2,1.8 4.4,2.2 3.7,2.7 C3.2,3.1 2.8,3.5 2.4,3.9 C0.5,6 -0.3,8.9 0.1,11.6 Z" id="Shape"></path></g></g></svg>'
  },
  android: {
    name: 'Backend/API',
    id: 'backend-api',
    href: 'https://auth0.com/docs/quickstart/backend',
    external: true,
    icon: '<svg width="20px" height="18px" viewBox="0 0 20 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="backend" fill="#EB5424" fill-rule="nonzero"><path d="M8.3,13.9 C8.3,11.9 6.7,10.2 4.6,10.2 C2.6,10.2 0.9,11.8 0.9,13.9 C0.9,15.9 2.5,17.6 4.6,17.6 C6.7,17.6 8.3,15.9 8.3,13.9 Z" id="Shape"></path><circle id="Oval" cx="16.3" cy="13.9" r="3.7"></circle><circle id="Oval" cx="10.5" cy="3.7" r="3.7"></circle><rect id="Rectangle-path" transform="translate(6.848375, 9.960895) rotate(-57.487502) translate(-6.848375, -9.960895) " x="1.59821451" y="8.86086137" width="10.500321" height="2.20006725"></rect><rect id="Rectangle-path" transform="translate(14.085660, 9.966595) rotate(-32.507667) translate(-14.085660, -9.966595) " x="12.9856855" y="4.71671667" width="2.19994901" height="10.4997567"></rect></g></g></svg>'
  },
  'all-quickstarts': {
    name: 'Mobile',
    id: 'mobile',
    href: ' https://auth0.com/docs/quickstart/native',
    external: true,
    icon: '<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="mobile" fill-rule="nonzero"><path d="M2.6,15.8 L10.4,15.8 C10.9,15.8 11.3,16.2 11.3,16.7 C11.3,17.2 10.9,17.6 10.4,17.6 L0.9,17.6 C0.4,17.6 0,17.2 0,16.7 L0,7.1 C0,6.6 0.4,6.2 0.9,6.2 C1.4,6.2 1.8,6.6 1.8,7.1 L1.8,14.9 C1.7,15.4 2.1,15.8 2.6,15.8 Z" id="Shape" fill="#EB5424"></path><path d="M12,13.5 C12,14 11.6,14.4 11.1,14.4 L4,14.4 C3.5,14.4 3.1,14 3.1,13.5 L3.1,6.4 C3.1,5.9 3.5,5.5 4,5.5 C4.5,5.5 4.9,5.9 4.9,6.4 L4.9,11.8 C4.9,12.3 5.3,12.7 5.8,12.7 L11.2,12.7 C11.6,12.6 12,13 12,13.5 Z" id="Shape" fill="#EB5424"></path><path d="M12,6.4 L12,10.4 C12,10.9 11.6,11.3 11.1,11.3 L7.1,11.3 C6.6,11.3 6.2,10.9 6.2,10.4 L6.2,6.4 C6.2,5.9 6.6,5.5 7.1,5.5 L11.1,5.5 C11.6,5.5 12,5.9 12,6.4 Z" id="Shape" fill="#EB5424"></path><path d="M11.3,12.6 L11.3,14.3 L12.7,14.3 L12.7,12.6 L11.3,12.6 Z M6.2,4.9 L6.2,6.3 L10.4,6.3 C10.9,6.3 11.3,6.7 11.3,7.2 L11.3,11.4 L12.7,11.4 L12.7,5.7 C12.7,5.2 12.3,4.8 11.8,4.8 L6.2,4.8 L6.2,4.9 Z M3.1,6.2 L4.8,6.2 L4.8,4.9 L3.1,4.9 L3.1,6.2 Z" id="Shape" fill="#F1F2F2"></path><path d="M14.4,13.5 C14.4,14 14,14.4 13.5,14.4 L4,14.4 C3.5,14.4 3.1,14 3.1,13.5 L3.1,4 C3.1,3.5 3.5,3.1 4,3.1 C4.5,3.1 4.9,3.5 4.9,4 L4.9,11.8 C4.9,12.3 5.3,12.7 5.8,12.7 L13.6,12.7 C14,12.6 14.4,13 14.4,13.5 Z" id="Shape" fill="#EB5424"></path><path d="M15.1,3.3 L15.1,10.4 C15.1,10.9 14.7,11.3 14.2,11.3 L7.1,11.3 C6.6,11.3 6.2,10.9 6.2,10.4 L6.2,3.3 C6.2,2.8 6.6,2.4 7.1,2.4 L14.2,2.4 C14.7,2.4 15.1,2.8 15.1,3.3 Z" id="Shape" fill="#EB5424"></path><path d="M6.2,1.7 L6.2,3.1 L13.5,3.1 C14,3.1 14.4,3.5 14.4,4 L14.4,11.3 L15.8,11.3 L15.8,2.6 C15.8,2.1 15.4,1.7 14.9,1.7 L6.2,1.7 Z" id="Shape" fill="#F1F2F2"></path><path d="M17.5,0.9 L17.5,10.4 C17.5,10.9 17.1,11.3 16.6,11.3 L7.1,11.3 C6.6,11.3 6.2,10.9 6.2,10.4 L6.2,0.9 C6.2,0.4 6.6,0 7.1,0 L16.6,0 C17.1,0 17.5,0.4 17.5,0.9 Z" id="Shape" fill="#EB5424"></path></g></g></svg>'
  }
};
var arrayItems = exports.arrayItems = Object.keys(contentItems);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */

// https://developer.mozilla.org/docs/Web/JavaScript/Referencia/Objetos_globales/Array/find

if (!Array.prototype.find) {
  Array.prototype.find = function (predicate) {
    'use strict';

    if (this == null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(46);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(45);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = _react2.default.createContext || createReactContext;
module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(32);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dropdown":"_1bIk","is-open":"_2Ism","twoBlock":"_3j1_","platformDropdown":"_126L","solutionsDropdown":"_1gCd","whyDropdown":"_10Eu","developersDropdown":"_1xI2","footer-list":"_14MM","footer-highlight":"_1CvT"};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"baseHighlight":"_2Lw9","content":"_3gp2","title":"_3LEU","text":"_1FRt","link":"_1WsL","highlight":"UAL6 _2Lw9","moreHighlight":"_2rad _2Lw9","section-title":"_3vyR","time":"_1zTu"};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"dropdownList":"_3qAr","stackedList":"_2d8P","highlight":"_1ds1","twoColList":"__I0","twoColListBig":"mPj3","moreDropdownList":"s_3k","header-title":"_17RU","section-title":"_1jg-","hasArrow":"_3a__","section-description":"fSWW","multi-list":"_3VwG","title-list":"wkWT"};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item":"_3v_7","singleItem":"_1ci6","icon":"_3bSm","icon-css":"_4Xdi","text":"-gCQ","itemPrefix":"_1Ac8","arrowItem":"_1Z4r _3v_7","moreItem":"_3F2P"};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"featured":"P2u8","featured-content":"pUyl","featured-more":"_1SDn","featured-title":"tE1s","featured-description":"_1Z0o","close-notification":"_2DjR","notificationOpen":"_3YWg","dropdownOpen":"y6Uj","theme-light":"_1ymv","featured-icon":"m6uH"};

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer-link":"AjX7","icon":"_1l50","text":"fFLa"};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"head":"hCiq","theme-dark":"_1gg_","logo":"_3yAY","dropdownOpen":"-S2z","brand":"_2uQu","toggleButton":"_1fl7","closeButton":"_1yKj","iconBar":"_1p6r","bounce":"_12jj"};

/***/ }),
/* 42 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"item":"_2kF_","simple-list":"_22dz","link":"_3BoP","text":"_23zg","item-more":"_3C8p","is-dropdown-open":"_31jh","theme-dark":"g13I","item-caret":"_37hu","dropdown-caret":"_2Oii","item-why-auth0":"_2VGR","item-developers":"_1r7x","item-platform":"_1qTi","item-solutions":"hIvN"};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header-main":"_2qoY","is-notification-open":"_2KWL","header":"_3TAQ","theme-dark":"_3uJX","pulse":"_199i","theme-gray":"_2__8","is-dropdown-open":"_3sHQ","menu":"_2IVQ","collapse":"_3scO","main-navigation":"_3TmG","navigation":"wixE","buttons-group":"_2fCs","focusable":"VXau","overflow":"_1AGc","login-button":"_2Vg9","login-button--dark":"QN_e","signup-button":"_3POG","menu-mobile":"_1yjk"};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(6);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(49)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(6);
var invariant = __webpack_require__(44);
var ReactPropTypesSecret = __webpack_require__(48);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

module.exports = [{"name":"About Us","id":"about-us","href":"https://auth0.com/about"},{"name":"Customers","id":"customers","href":"https://auth0.com/customers"},{"name":"Blog","id":"blog","href":"https://auth0.com/blog"},{"name":"Case Studies","id":"case-studies","href":"https://auth0.com/learn/#case-studies"},{"name":"Press Releases","id":"press-releases","href":"https://auth0.com/press"},{"name":"Documentation","id":"documentation","href":"https://auth0.com/docs"},{"name":"Resources","id":"resources","href":"https://auth0.com/resources"},{"name":"Support","id":"support","href":"https://support.auth0.com/"},{"name":"Security","id":"security","href":"https://auth0.com/security"},{"name":"Careers","id":"careers","href":"https://auth0.com/jobs"}]

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// web-header.js